import React, { Fragment, useState, useEffect } from "react";
import Select from "react-select";
import { fetchJson } from "../../lib/Fetching";

export default function TestingCategorySelect({ value, onChange }) {
  const [options, setOptions] = useState([]);

  const fetchData = search => {
    return fetchJson("/testing/testing_categories.json").then(records => {
      var options = [{ label: "All", value: null }].concat(
        records.map(m => ({ label: m.name, value: m.id }))
      );
      setOptions(options);
      return options;
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const selectedValue = options.filter(o => o.value === value);

  if (options.length === 0) return null;

  return (
    <Select
      value={selectedValue}
      placeholder={"Find Testing Category"}
      isMulti={false}
      id="testing_category_id"
      options={options}
      onChange={onChange}
      isClearable={true}
    />
  );
}
